import { FC } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Navigate, useLocation } from "react-router";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  const { authStatus } = useAuthenticator();
  const location = useLocation();

  return authStatus === "authenticated" ? (
    children
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default ProtectedRoute;
